function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: "#ffffff"
});

var _ref3 = /*#__PURE__*/React.createElement("title", null, "pause");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "20 pause"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14,3V29a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V3A1,1,0,0,1,7,2h6A1,1,0,0,1,14,3ZM25,2H19a1,1,0,0,0-1,1V29a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V3A1,1,0,0,0,25,2Z"
}));

var SvgPause = function SvgPause(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2395ff",
    viewBox: "0 0 32 32",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPause, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pause.8b0b54fe.svg";
export { ForwardRef as ReactComponent };